import type { FilterOption, IndividualBundleOption } from '../../types/filters';
import type { Product } from '../../types/product';
import SearchFiltersSidebar from './SearchFiltersSidebar';

interface SearchFiltersOffcanvasProps {
  group: 'purchased' | 'related' | 'fullCatalog';
  prefix: string;
  filters: {
    collection: FilterOption[];
    category: FilterOption[];
    subCategory: FilterOption[];
    individualBundle: IndividualBundleOption[];
    showBundleFilters: boolean;
  };
  filteredProducts: Product[];
}

export default function SearchFiltersOffcanvas({ group, prefix, filters, filteredProducts }: SearchFiltersOffcanvasProps) {
  return (
    <div className="col-12 col-sm-6 col-md-8 d-lg-none">
      <button
        className="btn btn-outline-primary fw-600"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target={`#${prefix}-offcanvas-filters`}
        aria-controls={`${prefix}-offcanvas-filters`}
      >
        &#43; Show Search and Filters
      </button>
      <div
        className="offcanvas offcanvas-start offcanvas-filters"
        data-bs-scroll="true"
        tabIndex={-1}
        id={`${prefix}-offcanvas-filters`}
        aria-labelledby={`${prefix}-offcanvas-filters`}
      >
        <div className="offcanvas-header">
          <h3 className="offcanvas-title text-theme-success">Search and Filters</h3>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div className="offcanvas-body">
          <SearchFiltersSidebar group={group} prefix={prefix} filters={filters} filteredProducts={filteredProducts} />

          <div className="text-end my-4">
            <button
              className="btn btn-outline-secondary fw-600 px-4"
              type="button"
              data-bs-dismiss="offcanvas"
              aria-label="Apply/Close"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
